import { FormControl, InputLabel, MenuItem, Select, FormHelperText } from "@mui/material";
import { ElementType, useState } from "react";
import { Training } from "@my-helpers/common";

interface HelperTrainingProps {
    selected: string;
    trainings: Training[];
    handleInputChange: (trainingId: string) => void;
}

export const HelperTraining: ElementType<HelperTrainingProps> = (
    { selected, trainings, handleInputChange }) => {
    const [isFocused, setIsFocused] = useState(false);

    const getHelperText = () => {
        if (!selected) {
            return "required";
        }
        return ' '; // empty string to maintain spacing
    };

    return (
        <FormControl 
            sx={{ 
                minWidth: '200px', 
                maxWidth: '300px',
                flex: 1,
                // Keep label gray even in error state
                '& .MuiInputLabel-root.Mui-error': {
                    color: 'text.secondary',
                },
                '& .MuiInputLabel-root.Mui-error.Mui-focused': {
                    color: 'error.main', // Show red when focused and in error state
                }
            }}
            error={!selected && isFocused}
        >
            <InputLabel 
                id="select-training-label"
                size="small"
            >
                Training
            </InputLabel>
            <Select
                value={selected}
                onChange={(e) => handleInputChange(e.target.value)}
                labelId="select-training-label"
                label="Training"
                required
                size="small"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            >
                {trainings.map(training => (
                    <MenuItem 
                        key={training.id} 
                        value={training.id}
                    >
                        {training.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText 
                sx={{
                    marginLeft: 0, // Remove default left margin to align with border
                }}>
                {getHelperText()}
            </FormHelperText>
        </FormControl>
    );
}